import type { RibbonControlProps } from "owa-acui";
import { constructKeytip, createAppButton } from "owa-command-ribbon";
import { getDefaultRibbonStyles } from "owa-command-ribbon-styles/lib/util/getDefaultRibbonStyles";
import { owaComputedFn } from "owa-computed-fn";
import { lazyShowAddressBook } from "owa-add-recipients-dialog/lib/addressBook";
import BookContactsRegular from "owa-fluent-icons-svg/lib/icons/BookContactsRegular";
import loc from "owa-localize";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { type MailRibbonControlId, type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import { ribbonAddressBookLabel, ribbonAddressBookTooltip } from "./addressBook.locstring.json";

function openAddressBook() {
    lazyShowAddressBook.importAndExecute(getModuleContextMailboxInfo(), window);
}

export const getAddressBookControl: () => RibbonControlProps = owaComputedFn(function getAddressBookControl(): RibbonControlProps {
    return createAppButton({
        id: 502,
        label: loc(ribbonAddressBookLabel),
        onExecute: openAddressBook,
        keytipProps: constructKeytip([1], 502),
        icon: BookContactsRegular,
        styles: getDefaultRibbonStyles(),
        mailboxInfo: getModuleContextMailboxInfo(),
        overrides: {
            customTooltip: loc(ribbonAddressBookTooltip),
        },
    });
});
